import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy,
	ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { MatInputModule } from '@angular/material/input';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ProductA2c } from '../../../../models/eorder';
import { InputNumberDirective } from '../../../../../shared/directives/input-number.directive';

interface AddToCartProvider {
	onClickAddToCart?: (params?: ProductA2c, itemCount?: number) => void;
	inputParams(params: ICellRendererParams<unknown, unknown>): AddToCartParam | undefined;
}

interface AddToCartParam {
	buttonLabel: string;
	templateNumber: number;
	product: ProductA2c;
}

@Component({
	selector: 'copo-add-to-cart',
	templateUrl: './add-to-cart.component.html',
	styleUrl: './add-to-cart.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		InputNumberDirective,

		MatInputModule
	]
})
export class AddToCartComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;
	addToCartHandler!: (params?: ProductA2c, itemCount?: number) => void;

	params?: ICellRendererParams<unknown, unknown>;
	routerLinkParams: AddToCartParam | undefined;
	buttonLabel = '';
	numberControl = new FormControl('1');
	confirmationPopupSub: Subscription | undefined;

	constructor(
		readonly changeDetectorRef: ChangeDetectorRef
	) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		if (!params.colDef) {
			return;
		}
		this.params = params;
		this.routerLinkParams = (<AddToCartProvider> params.colDef.cellRendererParams).inputParams(params);
		this.buttonLabel = this.routerLinkParams ? this.routerLinkParams.buttonLabel : '';
		this.addToCartHandler = (<AddToCartProvider> params.colDef.cellRendererParams)
			.onClickAddToCart ?? (() => { /* no-op */ });
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
		return true;
	}

	addToCart() {
		if (this.routerLinkParams && this.numberControl.value) {
			const product: ProductA2c = { ...this.routerLinkParams.product };
			this.addToCartHandler(product, Number(this.numberControl.value));
		}
	}
}
